import React from 'react';
import {
  AlertDialog,
  AlertDialogAction,
  AlertDialogCancel,
  AlertDialogContent,
  AlertDialogDescription,
  AlertDialogFooter,
  AlertDialogHeader,
  AlertDialogTitle,
} from '../ui/alert-dialog';
import { AlertTriangle, Trash2 } from 'lucide-react';
import { ScenarioStatus } from '../../types/scenarios';

// Delete Validation Modals
interface DeleteErrorModalProps {
  open: boolean;
  onClose: () => void;
  status: ScenarioStatus;
  scenarioName: string;
}

export const DeleteErrorModal: React.FC<DeleteErrorModalProps> = ({
  open,
  onClose,
  status,
  scenarioName,
}) => {
  const getMessage = () => {
    if (status === 'active') {
      return 'Cannot delete an active scenario. Park it first, then delete.';
    }
    return 'Cannot delete this scenario.';
  };

  return (
    <AlertDialog open={open} onOpenChange={onClose}>
      <AlertDialogContent>
        <AlertDialogHeader>
          <AlertDialogTitle className="flex items-center gap-2">
            <AlertTriangle className="h-5 w-5 text-red-500" />
            Cannot Delete Scenario
          </AlertDialogTitle>
          <AlertDialogDescription className="text-base">
            {getMessage()}
          </AlertDialogDescription>
        </AlertDialogHeader>
        <AlertDialogFooter>
          <AlertDialogAction onClick={onClose}>OK</AlertDialogAction>
        </AlertDialogFooter>
      </AlertDialogContent>
    </AlertDialog>
  );
};

interface DeleteConfirmModalProps {
  open: boolean;
  onClose: () => void;
  onConfirm: () => void;
  scenarioName: string;
}

export const DeleteConfirmModal: React.FC<DeleteConfirmModalProps> = ({
  open,
  onClose,
  onConfirm,
  scenarioName,
}) => {
  return (
    <AlertDialog open={open} onOpenChange={onClose}>
      <AlertDialogContent>
        <AlertDialogHeader>
          <AlertDialogTitle className="flex items-center gap-2">
            <Trash2 className="h-5 w-5 text-red-500" />
            Delete Scenario
          </AlertDialogTitle>
          <AlertDialogDescription className="text-base">
            Delete <span className="font-semibold">"{scenarioName}"</span>? This cannot be undone.
          </AlertDialogDescription>
        </AlertDialogHeader>
        <AlertDialogFooter>
          <AlertDialogCancel onClick={onClose}>Cancel</AlertDialogCancel>
          <AlertDialogAction
            onClick={onConfirm}
            className="bg-red-600 hover:bg-red-700 focus:ring-red-600"
          >
            Delete
          </AlertDialogAction>
        </AlertDialogFooter>
      </AlertDialogContent>
    </AlertDialog>
  );
};

